import React from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import logo from './images/logo.png'; 
import raigLogo from './images/footer-img/2.RAIG_FooterLogos_UK.20230714081542.svg';
import gamstopLogo from './images/footer-img/3.GAMSTOP_FooterLogos_UK.20230714081600.svg';
import gamecareLogo from './images/footer-img/4.GameCare_FooterLogos_UK.20230714081627.svg';
import begambleLogo from './images/footer-img/5.BeGambleAware_FooterLogos_UK.20230714081641.svg';
import gamblingTherapyLogo from './images/footer-img/6.GamblingTherapy_FooterLogos_UK.20230714081659.svg';
import eighteenPlusLogo from './images/18+.png';

function FooterBlack() {
  const location = useLocation(); // Hook to get the current location

  // Check if the current path contains "/au"
  const isAU = location.pathname.includes('/au');

  return (
    <section className="end">
      <div className="container">
        <div style={{ marginBottom: '16px', paddingBottom: '16px' }} className="d-flex justify-content-between res-foot">
          <div className="wrapper-footer-img" style={{ marginRight: '20px' }}>
            <Link className="navbar-brand" to={isAU ? "/au" : "/"}>
              <img src={logo} alt="λογότυπο" /> <span>AegeanWhispersgrc</span>
            </Link>
            <div className="footer-img">
              <img src={raigLogo} alt="Λογότυπο RAIG" />
              <img src={gamstopLogo} alt="Λογότυπο Gamstop" />
              <img src={gamecareLogo} alt="Λογότυπο GameCare" />
              <img src={begambleLogo} alt="Λογότυπο BeGambleAware" />
              <img src={gamblingTherapyLogo} alt="Λογότυπο Gambling Therapy" />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
            <img style={{ width: '32px' }} src={eighteenPlusLogo} alt="18+" />
            <span style={{ fontSize: 'small', marginTop: '10px' }}>
              Το AegeanWhispersgrc δημοσιεύει αξιολογήσεις διαδικτυακών καζίνο και δεν ευθύνεται για ενέργειες ή συνέπειες
              που σχετίζονται με τη χρήση ιστότοπων τρίτων. Όλες οι πληροφορίες παρέχονται αποκλειστικά για ενημερωτικούς σκοπούς,
              παρακαλώ ελέγξτε τους όρους και τις προϋποθέσεις κάθε καζίνο απευθείας στις πλατφόρμες τους.
            </span>
          </div>
        </div>

        <hr style={{ border: '0.5px solid gray', margin: '20px 0' }} />

        <div className="row d-flex justify-content-between">
          <div className="col-md-6 d-flex justify-content-start">
            <p className="cw">© Όλα τα δικαιώματα διατηρούνται 2024</p>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <p className="cw">
              <Link to={isAU ? "/au/privacy-policy" : "/privacy-policy"}>Πολιτική Απορρήτου</Link>
            </p>
            <p className="cw ml-3">
              <Link to={isAU ? "/au/terms-and-conditions" : "/terms-and-conditions"}>Όροι και προϋποθέσεις</Link>
            </p>
            <p className="cw ml-3">
              <Link to={isAU ? "/au/cookie-policy" : "/cookie-policy"}>Πολιτική Cookies</Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FooterBlack;
